// Pricing helpers shared by admin + public views.

export const PRICE_TYPES = [
  { value: 'fixed', label: 'Fixed price' },
  { value: 'from', label: 'From (starting price)' },
  { value: 'quote', label: 'Quote on inspection' }
];

/** "$1,234.50" — always two decimals (quotes, totals). */
export function formatMoney(n) {
  return '$' + (Number(n) || 0).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** "$250" or "$249.50" — whole dollars when possible (price chips). */
export function formatPrice(n) {
  const v = Number(n) || 0;
  return '$' + v.toLocaleString('en-AU', { minimumFractionDigits: Number.isInteger(v) ? 0 : 2, maximumFractionDigits: 2 });
}

/** Short customer-facing price label for a job type, or '' when there is nothing to show. */
export function priceLabel(service) {
  if (!service) return '';
  const hasPrice = service.price !== null && service.price !== undefined && service.price !== '';
  const type = service.price_type || (hasPrice ? 'fixed' : 'quote');
  if (type === 'quote') return 'Quote on inspection';
  if (!hasPrice) return '';
  if (Number(service.price) === 0) return 'Free';
  return type === 'from' ? `From ${formatPrice(service.price)}` : formatPrice(service.price);
}
